/**
 * Returns combined ratings
 *
 * @param {array} ratings
 * @param {array} ratingTypes
 *
 * @returns {array}
 */
export const getWsProductRatings = (ratings = [], ratingTypes = []) => {
  const mergedRatings = []

  ratingTypes.forEach(({ Id, Name: TypeName }) => {
    ratings.forEach(({ Value, Type: { Name } }) => {
      if (TypeName === Name) {
        mergedRatings.push({ Id, TypeName, Value })
      }
    })

    !isRatingExist(mergedRatings, Id) && mergedRatings.push({ Id, TypeName, Value: 0 })
  })

  return mergedRatings
}

// Check if rating exists
const isRatingExist = (ratings, ratingId) => ratings.some(({ Id }) => ratingId === Id)
